import { buildRoomsMapLayer } from "@lib/logic";
import { createMeetingRoomRequestContext, getMeetingRoomRequestState, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { useFacilityMarkers } from "../../../organisms/hereAndNow/useFacilityMarkers";
import { HaNContext } from "../shell/HaNContext";
import { HaNMapStageContext, useHaNMapLayer } from "../shell/regions/HaNMapStageContext";

export const RoomsMap = () => {
  const { tab } = useRequiredContext(HaNContext);
  const { floorId } = useRequiredContext(HaNMapStageContext);

  if (tab !== "rooms" || !floorId) return null;

  return <RoomsMapLayer floorId={floorId} />;
};

// Builds the tab's layer for the page's one map, which the map stage draws
const RoomsMapLayer = ({ floorId }: { floorId: string }) => {
  const { building, rooms, filterData } = useRequiredContext(HaNContext);
  const buildingId = building.buildingId ?? "";

  // The window the rooms list shows, so the map and the list always agree
  const request = createMeetingRoomRequestContext({
    buildingId,
    selectedFloorId: floorId,
    startDateTime: rooms.roomDateTimes.startDateTime,
    endDateTime: rooms.roomDateTimes.endDateTime,
  });
  const suggestions = useAppSelector(state => getMeetingRoomRequestState(state, request)?.meetingRoomSuggestion);
  const facilityMarkers = useFacilityMarkers(buildingId, floorId);

  const layer = buildRoomsMapLayer({ floorId, rooms: filterData.rooms.filteredData, suggestions, facilityMarkers });

  useHaNMapLayer(layer);

  return null;
};
